// Utils
import { isDateItemWithinDateRange } from 'NewAngular/features/components/date-controls/single-date-picker/utils/single-date-picker-utils';
import * as i0 from "@angular/core";
/**
 * Is Date Within Date Range Pipe
 *
 * Checks if a given date item is inside a date range defined by two Date objects
 */
export class isDateItemWithinDateRangePipe {
    transform(dateItem, startDate, endDate) {
        return isDateItemWithinDateRange(dateItem, startDate, endDate);
    }
}
isDateItemWithinDateRangePipe.ɵfac = function isDateItemWithinDateRangePipe_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || isDateItemWithinDateRangePipe)(); };
isDateItemWithinDateRangePipe.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "isDateItemWithinDateRange", type: isDateItemWithinDateRangePipe, pure: true, standalone: false });
